import { render } from "./AppDetails.vue.js?vue&type=template&id=25e3d5e0!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppDetails.vue?vue&type=template&id=25e3d5e0"
import script from "./AppDetails.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppDetails.vue?vue&type=script&lang=js"
export * from "./AppDetails.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/create-dashboard/views/AppDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25e3d5e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25e3d5e0', __exports__)) {
    api.reload('25e3d5e0', __exports__)
  }
  
  module.hot.accept("./AppDetails.vue.js?vue&type=template&id=25e3d5e0!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppDetails.vue?vue&type=template&id=25e3d5e0", () => {
    api.rerender('25e3d5e0', render)
  })

}


export default __exports__